import { render, staticRenderFns } from "./AscHealthScorePlotWrapper.vue?vue&type=template&id=b97b6c7a&"
import script from "./AscHealthScorePlotWrapper.vue?vue&type=script&lang=js&"
export * from "./AscHealthScorePlotWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscHealthScorePlotWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports